import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";

// core styles
import "./scss/volt.scss";

// vendor styles
import "react-datetime/css/react-datetime.css";

import HomePage from "./pages/HomePage";
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider } from "./contexts/AuthContext";
import { AcademicYearProvider } from "./contexts/AcademicYearContext";
import { SchoolProvider } from "./contexts/SchoolContext";
import { RoleProvider } from "./contexts/RoleContext";
import { ToastProvider } from "./contexts/ToastContext";

ReactDOM.render(
  <BrowserRouter>
    <AuthProvider>
      <RoleProvider>
        <SchoolProvider>
          <AcademicYearProvider>
            <ToastProvider>
              <ScrollToTop />
              <HomePage />
            </ToastProvider>
          </AcademicYearProvider>
        </SchoolProvider>
      </RoleProvider>
    </AuthProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
